const InterventionMixin = {
    methods: {
        waitingForResponsableTechnique(intervention) {
            return intervention.date_intervention != null
                && intervention.prestataire != null && !intervention.validation;
        },
    }
}
export default InterventionMixin;